import { styled } from "@mui/material/styles";
import { Box, Backdrop } from "@mui/material";

export const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  color: "#fff",
  zIndex: theme.zIndex.drawer + 1,
}));

export const RootWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const SectionTitle = styled("h4")(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: "500",
  fontSize: "18px",
  color: theme.palette.text.primary,
  [theme.breakpoints.down("md")]: {
    fontSize: "16px",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
  },
}));

export const SectionTitleLarge = styled("h3")(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: "bold",
  fontSize: "20px",
  color: theme.palette.text.primary,
  marginTop: 64,
  [theme.breakpoints.down("md")]: {
    fontSize: "18px",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "16px",
  },
}));
